import React, { FC, useEffect, useState } from 'react'
import {
    PageSectionFormContentProps,
    PageSectionSelectedWidget,
} from './PageSectionForm.d'
import { Alert, Col, Form, Row } from 'react-bootstrap'
import ListWidget from './widgets/ListWidget'
import CreateNewModule from '../../client/available-module/CreateNewModule'
import { ClientModule } from '../../../../features/security/security.slice'
import { Link } from 'react-router-dom'
import SearchWidget from './widgets/SearchWidget'

const PageSectionFormContent: FC<PageSectionFormContentProps> = ({
    availableWidgets,
    availablePages,
    availableModules,
    formikProps,
}) => {
    const [selectedWidgetType, setSelectedWidgetType] = useState('')

    const activeModules = availableModules.filter(
        (m: ClientModule) => m.active === 1
    )

    useEffect(() => {
        setSelectedWidgetType(
            formikProps.values.widget_data?.data_type?.toString()
        )
    }, [formikProps.values.widget_data, setSelectedWidgetType])

    return (
        <Row>
            {activeModules.length > 0 ? (
                <>
                    <Col lg={4}>
                        <Form.Group className="sfy-field mb-3">
                            <Form.Label>Data Type</Form.Label>
                            <Form.Select
                                aria-label="Select data type"
                                value={
                                    formikProps.values.widget_data?.[
                                        'data_type'
                                    ] || ''
                                }
                                onChange={(e) => {
                                    formikProps.setFieldValue('widget_data', {
                                        ...formikProps.values.widget_data,
                                        data_type: e.target.value,
                                    })
                                    setSelectedWidgetType(e.target.value)
                                }}
                            >
                                <option value="">
                                    {' '}
                                    -- Select data type --
                                </option>
                                {availableWidgets.map(
                                    (w: PageSectionSelectedWidget) => (
                                        <option key={w.code} value={w.code}>
                                            {w.name}
                                        </option>
                                    )
                                )}
                            </Form.Select>
                            <span className="bottom-border"></span>
                        </Form.Group>
                        <Form.Group className="sfy-field mb-3">
                            <Form.Label>Module</Form.Label>
                            <Form.Select
                                aria-label="Select widget module"
                                // disabled={!selectedWidgetType}
                                value={
                                    formikProps.values.widget_data?.[
                                        'module_id'
                                    ] || ''
                                }
                                onChange={(e) => {
                                    formikProps.setFieldValue('widget_data', {
                                        ...formikProps.values.widget_data,
                                        module_id: e.target.value,
                                    })
                                }}
                            >
                                <option value=""> -- Select module --</option>
                                {activeModules.map((m: ClientModule) => (
                                    <option key={m.id} value={m.id}>
                                        {m.name}
                                    </option>
                                ))}
                            </Form.Select>
                            <span className="bottom-border"></span>
                        </Form.Group>
                    </Col>
                    {(() => {
                        switch (selectedWidgetType) {
                            case 'LIST':
                                return (
                                    <Col lg={8}>
                                        <ListWidget
                                            formikProps={formikProps}
                                            availablePages={availablePages}
                                        />
                                    </Col>
                                )
                            case 'SEARCH':
                                return (
                                    <Col lg={8}>
                                        <SearchWidget
                                            formikProps={formikProps}
                                        />
                                    </Col>
                                )
                            case 'PRICING':
                                return (
                                    <Col lg={8}>
                                        <p>Pricing widget</p>
                                    </Col>
                                )
                            default:
                                return <Col lg={12}>Not a valid widget!</Col>
                        }
                    })()}
                </>
            ) : (
                <Col lg={12}>
                    <Alert variant="warning" className="border-0">
                        <strong>You have no modules!</strong> To use data types
                        you need to have at least one{' '}
                        <span className="text-danger">active</span> module.
                        <hr />
                        {availableModules.length > 0 ? (
                            <>
                                <p>
                                    Activate and use one of the following
                                    modules:
                                </p>
                                <ul className="list-group">
                                    {availableModules.map((m: ClientModule) => (
                                        <li
                                            key={m.id}
                                            className="list-group-item"
                                        >
                                            <Link
                                                to={'/client/modules/' + m.code}
                                            >
                                                {m.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                                <br />
                                Or{' '}
                            </>
                        ) : (
                            <></>
                        )}
                        <CreateNewModule />
                    </Alert>
                </Col>
            )}
        </Row>
    )
}

export default PageSectionFormContent
